import { GroupBase, Props } from "react-select";
import styled from "styled-components";
import { motion } from "framer-motion";
import { ErrorMessage } from "@shared/ui/ErrorMessage";
import CustomSelect from "../CustormSelect";

export function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  hasError,
  errorMessage,
  className,
  ...props
}: Props<Option, IsMulti, Group> & {
  hasError?: boolean;
  errorMessage?: string;
  className?: string;
}) {
  return (
    <StyledView className={className}>
      <CustomSelect {...props} hasError={hasError} />
      {hasError && errorMessage && <ErrorMessage message={errorMessage} />}
    </StyledView>
  );
}

const StyledView = styled(motion.div)`
  max-width: 100%;
  display: grid;
  justify-content: stretch;
`;
